<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BulkRentalServiceEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :resourceTitle="'Rental Services'|pgettext('BulkRentalServiceEditor|ResourceTitle')"
    :resourceKey="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      autofocus="first"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="service"
        :label="'Service'|pgettext('RentalService')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="service_enabled"
              v-model="item.$updates.service"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect2
          name="service"
          v-model="item.service"
          :dataSource="b_3468003412020058_dataSource"
          bind-object
          valueField="id"
          textField="name"
          :disabled="!item.$updates.service"
          required
          @optionSelected="evh_3468003412020058_optionSelected($event, {})"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="valid_from"
        :label="'Valid From'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="valid_from_enabled"
              v-model="item.$updates.valid_from"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="valid_from"
          v-model="item.valid_from"
          :disabled="!item.$updates.valid_from"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="valid_to"
        :label="'Valid To'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="valid_to_enabled"
              v-model="item.$updates.valid_to"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormDatetime
          name="valid_to"
          v-model="item.valid_to"
          :disabled="!item.$updates.valid_to"
          class="w-auto"
        >
        </ItpFormDatetime>
      </ItpFormGroup>
      <ItpFormGroup
        name="intermediated_service"
        :label="'Intermediated service'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="intermediated_service_enabled"
              v-model="item.$updates.intermediated_service"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormCheckbox
          type="number"
          name="intermediated_service"
          v-model="item.intermediated_service"
          :disabled="!item.$updates.intermediated_service"
          class="w-auto"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="inflation_indexed"
        :label="'Inflation indexed'|gettext"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="inflation_indexed_enabled"
              v-model="item.$updates.inflation_indexed"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormCheckbox
          type="number"
          name="inflation_indexed"
          v-model="item.inflation_indexed"
          :disabled="!item.$updates.inflation_indexed"
          class="w-auto"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="tariff_code"
        :label="'Tariff'|pgettext('RentalService')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        v-if="tariffs && tariffs.length"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="tariff_code_enabled"
              v-model="item.$updates.tariff_code"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect2
          name="tariff_code"
          v-model="item.tariff_code"
          :options="tariffs"
          clearable
          valueField="code"
          textField="code,name"
          :disabled="!item.$updates.tariff_code"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="billing_unit"
        :label="'Billing unit'|pgettext('RentalService')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="billing_unit_enabled"
              v-model="item.$updates.billing_unit"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormSelect2
          name="billing_unit"
          v-model="item.billing_unit"
          :options="units"
          valueField="symbol"
          textField="symbol"
          :disabled="!item.$updates.billing_unit"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <hr
        class="my-4"
      >
      </hr>
      <ItpFormGroup
        name="notes"
        :label="'Notes'|pgettext('RentalService')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        class="col"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <ItpFormCheckbox
              name="notes_enabled"
              v-model="item.$updates.notes"
            >
            </ItpFormCheckbox>
          </div>
        </div>
        <ItpFormTextarea
          name="notes"
          v-model="item.notes"
          :disabled="!item.$updates.notes"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms[formName] || !forms[formName].submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BulkRentalServiceEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getItemFromInput(...args: any[]) {
    const [inputItems, fields] = args;
    const fieldNames = _.map(fields, 'name');

    let result = {}

    _.each(inputItems, (item, i) => {
      if (i === 0) {
        result = _.pick(item, fieldNames);
      }

      for (const { name, defaultValue } of fields) {
        if (result[name] != item[name]) {
          result[name] = defaultValue;
          continue;
        }

        if (_.isUndefined(result[name])) {
          result[name] = defaultValue;
          continue;
        }

        if (result[name] != null) {
          result[name] = item[name];
        }
      }
    });

    result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {})
    return result;
  }

  getPayload(...args: any[]) {
    const [inputItems, item] = args;

    const updates = _.keys(_.pickBy(item.$updates, _.identity));

    if (!updates.length) {
      return
    }

    const update = _.pick(item, updates)

    return {
      items: _.map(inputItems, item => ({
        id: item.id,
        etag: item.etag,
        value: update
      }))
    };
  }

  @Prop({
    required: true,
    type: Array,
  })
  items!: array;

  @Watch('items')
  onItems(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("items")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  editableFields!: any;
  labelAlign!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  item!: any;

  async $$load_item() {
    return this.getItemFromInput(this.items, this.$data.editableFields)
  }

  services!: any;

  async $$load_services() {
    return this.$fn.fetch('suggest_product', {
      parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
    }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]))
  }

  tariffs!: any;

  async $$load_tariffs() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } })
  }

  units!: any;

  async $$load_units() {
    return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]))
  }

  invoiceGroups!: any;

  async $$load_invoiceGroups() {
    return this.$fn.fetch('list_product_invoice_group')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3468003412020058_dataSource!: any;
  dataMembers = ['editableFields', 'labelAlign', 'formId', 'formName', 'item', 'services', 'tariffs', 'units', 'invoiceGroups', 'ux', 'b_7315092382398562_modalBindings', 'b_3468003412020058_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        editableFields: [{
          name: "service",
        }
          ,
        {
          name: "name",
        }
          ,
        {
          name: "billing_unit",
        }
          ,
        {
          name: "invoice_notes",
        }
          ,
        {
          name: "invoice_notes",
        }
          ,
        {
          name: "valid_from",
        }
          ,
        {
          name: "valid_to",
        }
          ,
        {
          name: "tariff_code",
        }
          ,
        {
          name: "meter_factor",
        }
          ,
        {
          name: "intermediated_service",
        }
          ,
        {
          name: "inflation_indexed",
        }
          ,
        {
          name: "notes",
        }
          ,
        ]
        ,
        labelAlign: "right",
        formId: null,
        formName: "BulkRentalServiceEditor",
        item: null,
        services: null,
        tariffs: null,
        units: null,
        invoiceGroups: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
        b_3468003412020058_dataSource: {
          name: "suggest_product",
          parameters: {
            product_types: "service",
          }
          ,
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("BulkRentalServiceEditor", "Edit Service Properties"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9694_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9694, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_9700_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_9700, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_9698_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_9698, alias=save
    return {
      operation: "bulk_update_rental_service",
      data: this.getPayload(this.items, this.item),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_3468003412020058_setData_9702_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_3468003412020058_setData_9702, alias=undefined
    return {
      path: "item.service_id",
      value: this.item.service.id,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_3468003412020058_setData_9704_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_3468003412020058_setData_9704, alias=undefined
    return {
      path: "item.name",
      value: $event.data.option.name,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_3468003412020058_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3468003412020058_optionSelected.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9694: actions.CloseModalAction;
    evh_7315092382398562_close_9693: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9696: actions.CloseComponentAction;
    evh_2248226175642056_close_9695: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_9700: actions.CloseModalAction;
    evh_1040167445267876_success_9699: actions.EventHandlerImpl;
    act_1040167445267876_request_9698: actions.RequestAction;
    evh_1040167445267876_submit_9697: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_3468003412020058_setData_9702: actions.SetDataAction;
    evh_3468003412020058_optionSelected_9701: actions.EventHandlerImpl;
    act_3468003412020058_setData_9704: actions.SetDataAction;
    evh_3468003412020058_optionSelected_9703: actions.EventHandlerImpl;
    evh_3468003412020058_optionSelected: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_9706: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_9705: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9694 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9694_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9693 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9694,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9693],
      }
    );
    const act_2248226175642056_closeComponent_9696 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9695 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9696,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9695],
      }
    );
    const act_1040167445267876_closeModal_9700 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_9700_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_9699 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_9700,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_9698 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_9698_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_9699],
      }
    );
    const evh_1040167445267876_submit_9697 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_9698,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_9697],
      }
    );
    const act_3468003412020058_setData_9702 = new actions.SetDataAction(
      {
        actionArgs: this.act_3468003412020058_setData_9702_getActionArgs,
        events: [],
      }
    );
    const evh_3468003412020058_optionSelected_9701 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_setData_9702,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const act_3468003412020058_setData_9704 = new actions.SetDataAction(
      {
        actionArgs: this.act_3468003412020058_setData_9704_getActionArgs,
        events: [],
      }
    );
    const evh_3468003412020058_optionSelected_9703 = new actions.EventHandlerImpl(
      {
        action: act_3468003412020058_setData_9704,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_3468003412020058_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_3468003412020058_optionSelected_9701, evh_3468003412020058_optionSelected_9703],
      }
    );
    const act_1419464017721962_closeComponent_9706 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_9705 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_9706,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_9705],
      }
    );
    return {
      act_7315092382398562_closeModal_9694,
      evh_7315092382398562_close_9693,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9696,
      evh_2248226175642056_close_9695,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_9700,
      evh_1040167445267876_success_9699,
      act_1040167445267876_request_9698,
      evh_1040167445267876_submit_9697,
      evh_1040167445267876_submit,
      act_3468003412020058_setData_9702,
      evh_3468003412020058_optionSelected_9701,
      act_3468003412020058_setData_9704,
      evh_3468003412020058_optionSelected_9703,
      evh_3468003412020058_optionSelected,
      act_1419464017721962_closeComponent_9706,
      evh_1419464017721962_clickPreventStop_9705,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_request_9698,
    }
  }
}

Vue.component("BulkRentalServiceEditor", BulkRentalServiceEditor);

</script>